import React from 'react';
import { Checkbox, FormControlLabel } from '@material-ui/core';

const CustomCheckbox = (props) => {
  const { item, handleInputChange, color } = props;

  const onChange = (e) => {
    const currField = { ...item };
    currField.value = !currField.value;
    handleInputChange(currField);
  };

  return (
    <FormControlLabel
      control={<Checkbox color={color} checked={item.value} onChange={(e) => onChange(e)} />}
      label={item.fieldName}
    />
  );
};

export default CustomCheckbox;
